import styled from 'styled-components'
import { Select, AutoComplete } from 'antd'
import { TitleBox } from '../SectionProfile/styles'
import { ErrorColor, OrangeColor } from '../../../constants/constants'

export const DateContainer = styled.div`
  display: flex;
  margin-bottom: 15px;
`

export const DateWrapper = styled.div`
  margin-right: 20px;
`

export const LanguageSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const LanguageSelectorWrapper = styled.div`
  margin-bottom: 2px;
`
export const Selectantd = styled(Select)`
  margin: 5px 0 15px 0;
  border: 1px solid #667080;
  border-radius: 6px;
  font-size: 1rem;
  padding: 2px;
`

export const InputComplete = styled(AutoComplete)`
  padding: 0.06rem 0.06rem;
  background-color: #999999;
  border-radius: 5px;
`

export const TitleBoxTopMargin = styled(TitleBox)`
  margin-top: 10px;
`

export const TitleBoxBottomMargin = styled(TitleBox)`
  margin-bottom: 5px;
`

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

export const LastNameWrapper = styled.div`
  margin-left: 20px;
`

export const Name = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 10px;
`

export const TitleName = styled.div`
  font-weight: bold;
`
export const WrapperInputSkills = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.spaceStyle};
`

export const WrapperNotFound = styled.div`
  text-align: center;
`
export const WrapperAddSkill = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 470px;
  width: 100%;
  justify-content: ${(props) => props.spaceStyle};
  align-items: center;
`
export const AddSkillButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 0px 14px;
  margin-top: 20px;
  font-size: 1rem;
  color: ${OrangeColor};
`

export const FrameWorkSelectorWrapper = styled.div`
  align-self: flex-start;
`
export const LabelBox = styled.div`
  font-size: 12pt;
  font-weight: bold;
  align-self: flex-start;
`

export const LabelDelete = styled.span`
  font-size: 12px;
`

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 8px;
`
export const ErrorWrapper = styled.div`
  color: ${ErrorColor};
  padding: 0.5rem 0;
`
